<template>
  <div class="relative  mb-20 md:mt-96  h-screen overflow-hidden">
    <p class="md:text-4xl montserrat text-xl text-center diffrent-color-just2 text-white  font-bold ">
      Things you won’t find on my Resume
    </p>
    <div class="flex h-full items-center justify-center text-white">
      <div class="flex flex-col sm:flex-row w-full max-w-6xl mx-auto">
        <!-- Text Section -->
        <div class="flex-1 flex flex-col items-center justify-center px-8 mb-8 sm:mb-0">
          <!-- Title -->
          <h1 class="text-2xl font-semibold text-gray-300 mb-4">{{ currentTitle }}</h1>
          <!-- Typing Effect for Text -->
          <h2 class="text-md md:text-2xl diffrent-color font-bold">
            {{ displayedText }}
          </h2>
        </div>
        <!-- Image Section -->
        <div class="flex-1 relative flex items-center justify-center px-8">
  <img
    src="../assets/Subject.png"
    alt="Logo"
    loading="lazy"
    class="w-8  absolute left-[43%] md:bottom-[22rem] bottom-[16.5rem]   z-10 h-8 md:w-10 md:h-10 animate__animated"
    :style="{ transform: 'rotate(15deg)' }"
  />
  <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <img loading="lazy" :key="currentImage" :src="currentImage" alt="Polaroid" class="md:w-80 w-60 h-88 md:h-96 object-cover rounded-lg shadow-lg" />
  </transition>
</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnimatedContent',
  data() {
    return {
      titles: [
        "I am a...",
        "I am a...",
        "I love...",
        "I love...",
        "I am a...",
        "I am a...",
        "I love...",
      ],
      texts: [
        "Dog Lover",
        "Travel Enthusiast",
        "Watching Crime Documentaries",
        "Listening to Podcasts",
        "GOT Fan",
        "Potterhead...also a Slytherine",
        "Playing Board Games"
      ],
      images: [
        require('../assets/Group 1900 (1).png'),
        require('../assets/Group 1901.png'),
        require('../assets/Group 1902.png'),
        require('../assets/Group 1903.png'),
        require('../assets/Group 1904.png'),
        require('../assets/Group 1906.png'),
        require('../assets/Group 1905.png'),
      ],
      currentIndex: 0,
      displayedText: '', // For typing effect
      typingInterval: null,
    };
  },
  computed: {
    currentTitle() {
      return this.titles[this.currentIndex];
    },
    currentText() {
      return this.texts[this.currentIndex];
    },
    currentImage() {
      return this.images[this.currentIndex];
    }
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.texts.length;
      this.startTypingEffect();
    },
    startTypingEffect() {
      clearInterval(this.typingInterval);
      this.displayedText = '';
      let currentText = this.currentText;
      let i = 0;
      this.typingInterval = setInterval(() => {
        if (i < currentText.length) {
          this.displayedText += currentText[i];
          i++;
        } else {
          clearInterval(this.typingInterval);
        }
      }, 100); // Adjust typing speed here (100ms per character)
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.offsetHeight; // trigger reflow
      el.style.transition = 'opacity 1s';
      el.style.opacity = 1;
      done();
    },
    leave(el, done) {
      el.style.transition = 'opacity 1s';
      el.style.opacity = 0;
      done();
    }
  },
  created() {
    this.startTypingEffect();
    setInterval(this.nextSlide, 3000); // Adjust timing to match the typing effect duration
  },
  mounted() {
    this.startTypingEffect();
    setInterval(this.nextSlide, 3000); // Adjust timing to match the typing effect duration

    // Create an intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add the animation class when the image is in view
          entry.target.classList.add('animate__bounceInRight');
          // Stop observing the image
          observer.unobserve(entry.target);
        }
      });
    });

    // Target the image with alt "Logo"
    const logoImage = this.$el.querySelector('img[alt="Logo"]');
    if (logoImage) {
      observer.observe(logoImage);
    }
  },

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playwrite+CU:wght@100..400&display=swap');
.diffrent-color {
  color: #A0E9E5 !important;
  font-family: "Playwrite CU", cursive;
  font-optical-sizing: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
